var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b17162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
// module id = null
// module chunks = 